export enum ModalEvents {
  Opened = 'pp_modal_opened',
  Closed = 'pp_modal_closed'
}

export enum ModalNames {
  /* Cash or Finance - Build my deal */
  EditPayment = 'edit-payment-modal',
  IncompatibleLenders = 'incompatible-lenders-modal',
  LenderNotListed = 'lender-not-listed-modal',
  MonthlyPayment = 'monthly-payment-modal',
  /* Review Order - VIN Etching */
  VinEtching = 'vin-etching-modal',
  /* Review Order - Trade-in */
  TradeIn = 'trade-in-modal',
  /* Review Order - Carvana Care */
  CarvanaCare = 'carvana-care-modal',
  /* Review Order - Incomplete Steps */
  ReviewOrderIncompleteSteps = 'review-order-incomplete-steps-modal',
  /* Review Order - CA vehicle eligibility */
  ReviewOrderIneligibleVehicle = 'review-order-ineligible-vehicle-modal',
  /* Order Summary */
  OrderSummary = 'order-summary-modal',
  CreditApplied = 'credit-applied-modal',
  /* Transfer Method */
  TransferMethodDelivery = 'transfer-method-delivery-modal',
  TransferMethodNormalization = 'transfer-method-normalization-modal',
  TransferMethodPickup = 'transfer-method-pickup-modal',
  MapAppChooser = 'map-app-chooser-modal',
  /* Header - Lock Timer */
  LockTimer = 'lock-timer-modal',
  /* Header - Exchange */
  ExchangeModal = 'exchange-modal',
  /* Support Contact */
  SupportContact = 'support-contact-modal',
  /* Drivers License */
  DriversLicenseNameMatching = 'drivers-license-name-matching-modal',
  DriversLicenseNameUpdateFailed = 'drivers-license-name-update-failed-modal',
  DriversLicensePersonaConnecting = 'drivers-license-persona-connecting-modal',
  DriversLicenseRollbackInitiated = 'drivers-license-rollback-initiated-modal',
  DriversLicenseDocUpload = 'drivers-license-doc-upload-modal',
  DriversLicenseDocUploadExamples = 'drivers-license-doc-upload-examples-modal',
  /* Personal Details - Address */
  AddressNormalizationHome = 'address-normalization-home-modal',
  AddressNormalizationMailing = 'address-normalization-mailing-modal',
  AddressNormalizationDelivery = 'address-normalization-delivery-modal',
  CosignerNotAllowed = 'cosigner-not-allowed-modal',
  MailingAddressWarning = 'mailing-address-warning-modal',
  ForbiddenNewCarState = 'forbidden-new-car-state-modal',
  /* Trade-in - Valued */
  EmbeddedTradeAppraisal = 'embedded-trade-appraisal-modal',
  TradeInExpired = 'trade-in-expired-modal',
  TradeInPayoff = 'trade-in-payoff-modal',
  TradeInWsys = 'trade-in-wsys-modal',
  TradeInTradeBoost = 'trade-in-trade-boost-modal',
  NoDealerFees = 'no-dealer-fees-modal',
  /* Review Order - Included with purchase */
  SevenDayGuarantee = 'seven-day-guarantee-modal',
  /* GAP Coverage */
  GapCoverage = 'gap-coverage-modal',
  GapCoverageUnavailable = 'gap-coverage-unavailable-modal',
  /* Error Handling */
  SomethingWentWrong = 'something-went-wrong-modal',
  /* KIQ - Identity Verification */
  TimerExpired = 'timer-expired-modal',
  ExitWarning = 'exit-warning-modal',
  /* Transfer Schedule */
  TimeSlotSubmissionError = 'time-slot-submission-error-modal',
  GenericSubmissionError = 'generic-error-modal',
  DocumentUploadError = 'document-upload-error-modal',
  VinEtchingError = 'vin-etching-error-modal',
  /* Residency Verification */
  AcceptableDocuments = 'acceptable-documents-modal',
  ResidencyVerificationUploadModal = 'residency-verification-upload-modal',
  /* Order Placed Dashboard */
  CongratsModal = 'congrats-modal',
  /*Trade Verification*/
  TenDayPayoffTooltipModal = 'ten-day-payoff-tooltip-modal',
  TenDayPayoffErrorModal = 'ten-day-payoff-error-modal',
  TradeVerificationUploadModal = 'trade-verification-upload-modal',
  TradeVerificationDatePickerModal = 'trade-verification-date-picker-modal',
  TenDayPayoffFormTaskModal = 'ten-day-payoff-form-task-modal',
  TenDayPayoffLienMismatchModal = 'ten-day-payoff-lien-mismatch-modal',
  TenDayPayoffLastFourSsnModal = 'ten-day-payoff-last-four-ssn-modal',
  TenDayPayoffAccountNumberModal = 'ten-day-payoff-account-number-modal',
  /* Income Verification */
  IncomeDocumentUploadModal = 'income-document-upload-modal',
  IncomePayStubGrossPayTooltip = 'income-pay-stub-gross-pay-tooltip',
  IncomePayStubFormControl = 'income-pay-stub-form-control',
  /* Additional Income Verification */
  AdditionalIncomeDocumentUploadModal = 'additional-income-document-upload-modal',
  /* Incentives */
  IncentivesEligibility = 'incentives-eligibility-modal',
  /* Checkout - Verifications */
  VerificationAgreements = 'verification-agreements-modal',
  /* Autopay - Pricing details */
  AutopayPricingDetailsEnroll = 'autopay-pricing-details-enroll-modal',
  /* Add Bank Account disclosure (Plaid + manual entry) */
  AddBankAccount = 'add-bank-account-modal',
  /* Insurance Landing */
  InsuranceConsent = 'insurance-consent-modal',
  InsuranceQuote = 'insurance-quote-modal',
  InsuranceProgressiveDisclosures = 'insurance-progressive-disclosures-modal',
  /* Insurance Quote screens */
  InsuranceQuoteDeclined = 'insurance-quote-declined-modal',
  InsuranceQuotePaymentError = 'insurance-quote-payment-error-modal',
  InsuranceQuoteSomethingWentWrong = 'insurance-quote-something-went-wrong-modal',
  InsuranceQuotePaymentSuccess = 'insurance-quote-payment-success-modal',
  InsuranceQuotePaymentBreakdown = 'insurance-quote-payment-breakdown-modal',
  InsuranceQuoteLiabilityInfo = 'insurance-quote-liability-info-modal',
  InsuranceQuoteDeductiblesInfo = 'insurance-quote-deductibles-info-modal',
  InsuranceQuoteNonLiabilityInfo = 'insurance-quote-non-liability-info-modal',
  InsuranceQuoteCoveredDriversInfo = 'insurance-quote-covered-drivers-info-modal',
  InsuranceQuoteCoveredVehiclesInfo = 'insurance-quote-covered-vehicles-info-modal',
  /* Down Payment */
  BankAccountEntryDownPayment = 'bank-account-entry-down-payment-modal',
  CardEntryDownPayment = 'card-entry-down-payment-modal',
  CreditDownPayment = 'credit-down-payment-modal',
  RefundDueDownPayment = 'refund-due-down-payment-modal',
  ShippingFeeDownPayment = 'shipping-fee-down-payment-modal',
  PlaidEntryDownPayment = 'plaid-entry-down-payment-modal',
  DownPaymentFaq = 'down-payment-faq-modal',
  /* Autopay Enrollment */
  BankAccountEntryAutopayEnrollment = 'bank-account-entry-autopay-enrollment-modal',
  PlaidEntryAutopayEnrollment = 'plaid-entry-autopay-enrollment-modal',
  AutopayFinancingDetails = 'autopay-financing-details-modal',
  /* Checkout Verifications */
  VerificationTaskSheet = 'verification-task-sheet-modal',
  /* Complete Purchase */
  PlaidModalCompletePurchase = 'plaid-complete-purchase-modal',
  /* Plaid Explanation (shared DS - down payment + autopay) */
  PlaidExplanation = 'plaid-explanation-modal',
  /* Nav-rail */
  EditOrder = 'edit-order-modal',
  CancelOrder = 'cancel-order-modal',
  MobileNavigationDrawer = 'mobile-navigation-drawer-modal',
  /* Carvana Protection */
  ProtectionCoverage = 'protection-coverage-modal',
  ProtectionCustomize = 'protection-customize-modal',
  ProtectionEstimate = 'protection-estimate-modal',
  ProtectionLearnMore = 'protection-learn-more-modal',
  ProtectionRecommended = 'protection-recommended-modal',
  /* Slate Accessories */
  AccessoriesShippingAddress = 'accessories-shipping-address-modal',
  AccessoriesViewAll = 'accessories-view-all-modal',
  /* Carvana Protection */
  CarvanaProtectionDeductibleInfo = 'carvana-protection-deductible-info-modal',
  /* Payment Options - SoftPull MFE */
  SoftPull = 'softpull-modal',
  /* Identity - Persona SDK */
  Persona = 'persona-modal'
}
